module.exports = __webpack_public_path__ + "static/media/0.d0af0e5e.png";